module.exports = __webpack_public_path__ + "img/img11.4b0f4aec.png";